var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import * as dayjs from 'dayjs';
import { Vue, Component, } from 'vue-property-decorator';
import { isNotEmptyAny } from '@lhb/func';
import { filterTime } from '@/common/utils/ways';
var DateRange = /** @class */ (function (_super) {
    __extends(DateRange, _super);
    function DateRange() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /* data */
        _this.currentDate = [dayjs().format('YYYY-MM-DD'), dayjs().add(14, 'day').format('YYYY-MM-DD')];
        _this.pattern = 1; // 1 15天； 2 31天；3 年， 4 月模式
        return _this;
    }
    Object.defineProperty(DateRange.prototype, "pickerOptions", {
        get: function () {
            return {
                disabledDate: function (time) {
                    return time.getTime() > dayjs().add(5, 'year') || time.getTime() < dayjs().subtract(5, 'year');
                },
            };
        },
        enumerable: false,
        configurable: true
    });
    /* method */
    DateRange.prototype.handlePattern = function (pattern) {
        console.log("pattern = ", pattern);
    };
    DateRange.prototype.change = function (val) {
        if (isNotEmptyAny(val)) {
            var daysDiff = dayjs(val[1]).diff(dayjs(val[0]), 'day') + 1;
            console.log("daysDiff = ", daysDiff);
            if (daysDiff < 15) {
                this.$emit('change', [val[0], dayjs(val[0]).add(14, 'day').format('YYYY-MM-DD')], 1);
            }
            else if (daysDiff >= 15 && daysDiff < 90) {
                this.$emit('change', val, 2);
            }
            else {
                this.$emit('change', val, 4);
            }
        }
    };
    DateRange = __decorate([
        Component({
            components: {},
            filters: {
                filterDateFn: function (val, format) {
                    if (format === void 0) { format = 'YYYY.MM.DD'; }
                    return filterTime(val, format);
                },
            }
        })
    ], DateRange);
    return DateRange;
}(Vue));
export default DateRange;
